// Shared Cloudflare Turnstile helper for Materiaal Maatjes components
// Centralizes reading config from window.materiaalAjax.turnstile, waiting for API,
// rendering widgets, and resetting them. Keeps component code minimal and consistent.

const DEFAULTS = {
  enabled: false,
  siteKey: '',
  appearance: 'always',
  theme: 'auto',
}

function getConfig() {
  const cfg = (window && window.materiaalAjax && window.materiaalAjax.turnstile) || {}
  const siteKey = typeof cfg.siteKey === 'string' ? cfg.siteKey : ''
  return {
    enabled: !!(cfg.enabled && siteKey),
    siteKey,
    appearance: cfg.appearance || DEFAULTS.appearance,
    theme: cfg.theme || DEFAULTS.theme,
  }
}

function isEnabled() {
  const { enabled, siteKey } = getConfig()
  return !!(enabled && siteKey)
}

function waitForApi(timeoutMs = 5000) {
  if (window.turnstile && typeof window.turnstile.render === 'function') return Promise.resolve()
  return new Promise((resolve) => {
    const started = Date.now()
    const iv = setInterval(() => {
      if (window.turnstile && typeof window.turnstile.render === 'function') {
        clearInterval(iv)
        resolve()
      } else if (Date.now() - started > timeoutMs) {
        clearInterval(iv)
        resolve() // resolve anyway; caller can check window.turnstile
      }
    }, 50)
  })
}

function render(el, { sitekey, appearance, theme, onToken, onError, onExpired } = {}) {
  const cfg = getConfig()
  const opts = {
    sitekey: sitekey || cfg.siteKey,
    appearance: appearance || cfg.appearance,
    theme: theme || cfg.theme,
    callback: (token) => { if (typeof onToken === 'function') onToken(token) },
    'error-callback': () => { if (typeof onError === 'function') onError() },
    'expired-callback': () => { if (typeof onExpired === 'function') onExpired() },
  }
  return window.turnstile.render(el, opts)
}

function reset(widgetId) {
  try {
    if (window.turnstile && widgetId) window.turnstile.reset(widgetId)
  } catch (_) {}
}

export default {
  getConfig,
  isEnabled,
  waitForApi,
  render,
  reset,
}
